var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGotackleBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 577,
    height: 312,
    viewBox: "0 0 577 312",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "rounded-2xl",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5266_16131)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 577,
    height: 312,
    fill: "url(#paint0_linear_5266_16131)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5266_16131)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.732,
    y: 62.7166,
    width: 372.773,
    height: 372.773,
    rx: 93.1932,
    transform: "rotate(-6.83144 111.732 62.7166)",
    fill: "url(#paint1_linear_5266_16131)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.373,
    y: 65.5784,
    width: 366.224,
    height: 366.224,
    rx: 89.9186,
    transform: "rotate(-6.83144 115.373 65.5784)",
    stroke: "#9482FF",
    strokeWidth: 6.54912
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5266_16131)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 214.742,
    cy: 206.55,
    r: 38.5741,
    transform: "rotate(-6.83144 214.742 206.55)",
    fill: "url(#paint2_linear_5266_16131)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.742,
    cy: 206.55,
    r: 37.558,
    transform: "rotate(-6.83144 214.742 206.55)",
    stroke: "white",
    strokeWidth: 2.03231
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5266_16131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.108 193.797C410.641 191.004 415.485 190.545 419.479 192.627L456.36 211.847C461.957 214.764 464.13 221.667 461.213 227.265C458.296 232.863 451.393 235.036 445.795 232.118L427.15 222.401C428.232 257.631 420.551 285.95 406.832 307.437C390.457 333.084 366.079 348.023 340.303 353.289C289.559 363.658 231.317 336.365 218.958 278.413C217.642 272.24 221.579 266.168 227.753 264.852C233.926 263.535 239.998 267.473 241.314 273.646C250.532 316.871 294.664 339.284 335.727 330.893C355.855 326.781 374.74 315.224 387.566 295.136C398.123 278.6 404.978 255.627 404.356 225.116L386.056 239.587C381.105 243.502 373.917 242.662 370.002 237.711C366.087 232.76 366.926 225.572 371.878 221.657L407.108 193.797Z",
    fill: "url(#paint3_linear_5266_16131)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.108 193.797C410.641 191.004 415.485 190.545 419.479 192.627L456.36 211.847C461.957 214.764 464.13 221.667 461.213 227.265C458.296 232.863 451.393 235.036 445.795 232.118L427.15 222.401C428.232 257.631 420.551 285.95 406.832 307.437C390.457 333.084 366.079 348.023 340.303 353.289C289.559 363.658 231.317 336.365 218.958 278.413C217.642 272.24 221.579 266.168 227.753 264.852C233.926 263.535 239.998 267.473 241.314 273.646C250.532 316.871 294.664 339.284 335.727 330.893C355.855 326.781 374.74 315.224 387.566 295.136C398.123 278.6 404.978 255.627 404.356 225.116L386.056 239.587C381.105 243.502 373.917 242.662 370.002 237.711C366.087 232.76 366.926 225.572 371.878 221.657L407.108 193.797Z",
    stroke: "white",
    strokeWidth: 1.52423,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5266_16131",
    x: 30.44,
    y: -60.8844,
    width: 577.052,
    height: 577.052,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 30.4847,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5266_16131"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03231
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.4039
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5266_16131"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5266_16131",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5266_16131",
    x: 160.131,
    y: 167.972,
    width: 109.223,
    height: 109.222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.0332
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.01662
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5266_16131"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5266_16131",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5266_16131",
    x: 201.908,
    y: 190.571,
    width: 277.397,
    height: 197.705,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.0332
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.01662
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5266_16131"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5266_16131",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5266_16131",
    x1: 288.5,
    y1: 0,
    x2: 288.5,
    y2: 312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#705AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5266_16131",
    x1: 223.965,
    y1: 158.916,
    x2: 484.505,
    y2: 515.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#705AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948547,
    stopColor: "#423592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5266_16131",
    x1: 214.742,
    y1: 167.976,
    x2: 214.742,
    y2: 245.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5266_16131",
    x1: 334.827,
    y1: 200.76,
    x2: 459.272,
    y2: 257.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0CAF4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5266_16131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 577,
    height: 312,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotackleBackground);
export default __webpack_public_path__ + "static/media/gotackle-background.c79de5d0d504a9991849efc875d2b7d2.svg";
export { ForwardRef as ReactComponent };